import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Training from "./Training";
import {getLevelsByRole} from "../../../services/redux/Training/action";

const mapStateToProps = (state) => ({
    roleLevels: state.Training.listing
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLevelsByRole
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(Training);